
import Vue from "vue";
import AppProductListItem from "@/components/cashier/CashierProductListItem.vue";
import {IButton, IButtonConfig} from "@/models/dossier-configs/cashier";
import {SaleEditState} from "@/utils/sale-edit/sale-edit-state";
import {ProductService} from "@/services";


export default Vue.extend({
	props: {
		buttons: {
			type: Object as () => IButtonConfig,
			required: true
		},
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	methods: {
		add(){
			this.$emit("add");
		},
		edit(event:MouseEvent,index: number){
			event.preventDefault();
			this.$emit("edit",index);
		},
		async addProduct(button: IButton){
			if(button.ProductID){
				let p = await ProductService.getProduct(button.ProductID);
				this.$emit("add-product", p);
			}
		}
	},
	components: {
		AppProductListItem
	}
});
